export const SET_INPUT = 'login/SET_INPUT';
export const LOGIN_START = 'login/LOGIN_START';
export const LOGIN_COMPLETED = 'login/LOGIN_COMPLETED';
export const LOGIN_FAILED = 'login/LOGIN_FAILED';
export const MAGIC_LOGIN_USING_CREDENTIALS_START = 'login/MAGIC_LOGIN_USING_CREDENTIALS_START';
export const MAGIC_LOGIN_USING_CREDENTIALS_COMPLETED = 'login/MAGIC_LOGIN_USING_CREDENTIALS_COMPLETED';
export const MAGIC_LOGIN_USING_CREDENTIALS_FAILED = 'login/MAGIC_LOGIN_USING_CREDENTIALS_FAILED';
export const SET_OPEN_WRONG_LOGIN_PAGE_MODAL = 'login/SET_OPEN_WRONG_LOGIN_PAGE_MODAL';
export const CLEAR_ERROR_FIELD = 'login/CLEAR_ERROR_FIELD'
